/**
 * Desfecho do fluxo TARP → o que a UI oferece (GUPM-190 T1/T2). Domínio puro.
 * Single-source do mapeamento desfecho → ação/rótulo, fiel ao `updateTarpFinish`
 * do protótipo v5.10 (rótulo do botão de conclusão varia por terminal).
 */
import type { Outcome } from './flow';

/**
 * O desfecho permite registrar/abrir a TARP? `null` (checklist incompleto) e
 * `rotina` (concluído sem ocorrência — "nada anormal") NÃO registram; os demais sim.
 */
export function canRegistrar(outcome: Outcome | null): boolean {
  return outcome !== null && outcome !== 'rotina';
}

/**
 * Rótulo do botão de conclusão por desfecho (fiel ao V8). Só faz sentido para
 * desfechos registráveis (`canRegistrar`); `rotina` não tem botão de registrar.
 */
export function botaoRegistrarLabel(outcome: Outcome): string {
  switch (outcome) {
    case 'paebm':
      return '🆘 Registrar acionamento e ir ao PAEBM';
    case 'handoff':
      return '📤 Encaminhar para baixa da TARP (técnico)';
    case 'fim':
      return '✅ Concluir e Registrar TARP';
    case 'rotina':
      // Sem registro — mantido só para exaustividade do switch.
      return 'Concluir Registro de TARP';
  }
}
